import React from "react";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";

import Layout from "@/components/Page/Layout";
import Signin from "@/components/Page/Signin";
import { serverSidePage } from "@/utils/serverSide";
import { Website } from "@/types/website";
import { GetServerSideProps } from "next";
import { getProviders } from "next-auth/client";
import { TFunction } from "next-i18next";
import { useUser } from "@/hooks/useUser";
import { useRouter } from "next/router";

type Props = {
  website: Website;
  providers: any;
};

export const SigninPage = ({ providers }: Props): React.ReactElement => {
  const [session, loading, error] = useUser();
  const router = useRouter();

  React.useEffect(() => {
    if (!session?.user?.id || error) return;

    const locale = session.user.profile?.locale;
    if (router?.query?.to)
      router.push(`${router.query.to}`, `${router.query.to}`, { locale });
  }, [session, loading, router.query]);

  return <Signin providers={providers} />;
};

SigninPage.getLayout = function getLayout(
  page: React.ReactElement,
  t: TFunction
) {
  const { website } = page.props;

  return (
    <Layout title={t("users.signinNoun")} website={website}>
      {page}
    </Layout>
  );
};

export const getServerSideProps: GetServerSideProps = async ({
  locale,
  query,
  req,
}) => ({
  props: {
    providers: await getProviders(),
    ...(await serverSidePage(query, req)),
    ...(await serverSideTranslations(locale, ["common"])),
  },
});

export default SigninPage;
